import { useEffect, useLayoutEffect } from 'react';
import { Res, useCms } from '../../../state/api';
import { UiContainer } from '../../../state/ui';
import { CmsComponent } from '../../cms/CmsComponent';
import './TopBanner.css';

type TopBannerProps = {
	applyMobileOffset?: boolean;
};

export const TopBanner = ({ applyMobileOffset = false }: TopBannerProps): JSX.Element | null => {
	const { data: topbanner, isLoading } = useCms(Res.cmsComponent, { slug: 'top-banner' });
	const ui = UiContainer.useContainer();
	const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
	const windowWidth = ui.windowSize.width ?? (typeof window !== 'undefined' ? window.innerWidth : undefined);
	const isMobile = applyMobileOffset && windowWidth !== undefined && windowWidth < 820;

	// Keep mobile layout offset in sync with banner visibility.
	useIsomorphicLayoutEffect(() => {
		if (!applyMobileOffset) return;

		const offset =
			ui.isTopBannerOpen &&
			isMobile &&
			topbanner !== undefined &&
			Array.isArray(topbanner) &&
			topbanner.length > 0
				? 34
				: 0;
		document.documentElement.style.setProperty('--top-banner-offset', `${offset}px`);

		return () => document.documentElement.style.setProperty('--top-banner-offset', '0px');
	}, [applyMobileOffset, isMobile, ui.isTopBannerOpen, topbanner]);

	if (!ui.isTopBannerOpen) return null;

	return (
		<div className={`top-banner ${ui.isHeaderSticky ? 'sticky' : ''}`}>
			{!isLoading && Array.isArray(topbanner) && topbanner.length > 0 && <CmsComponent structure={topbanner} />}
		</div>
	);
};
